import axios from "axios";
import Config from "../../../config/index";
import {
  GET_FG_MODAL_FAILURE,
  GET_FG_MODAL_REQUEST,
  GET_FG_MODAL_SUCCESS,
  GET_FG_REPORT_DOWNLOAD_FAILURE,
  GET_FG_REPORT_DOWNLOAD_REQUEST,
  GET_FG_REPORT_DOWNLOAD_SUCCESS,
  GET_FG_REPORT_FAILURE,
  GET_FG_REPORT_REQUEST,
  GET_FG_REPORT_SUCCESS,
  GET_FG_TYPE_FAILURE,
  GET_FG_TYPE_REQUEST,
  GET_FG_TYPE_SUCCESS,
} from "./fgReportType";

let baseUrl = Config.baseUrl;

const getFgReportRequest = () => {
  return {
    type: GET_FG_REPORT_REQUEST,
  };
};

const getFgReportSuccess = (payload) => {
  return {
    type: GET_FG_REPORT_SUCCESS,
    payload: payload,
  };
};

const getFgReportFailure = (error) => {
  return {
    type: GET_FG_REPORT_FAILURE,
    payload: error,
  };
};

const getFgReport = (pageNo, rowsPerPage, search, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getFgReportRequest());
    let url = `${baseUrl}/reports/finish_goods?page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}&download=0`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getFgReportSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getFgReportFailure(err.message));
      });
  };
};

const getFgReportDownloadRequest = () => {
  return {
    type: GET_FG_REPORT_DOWNLOAD_REQUEST,
  };
};

const getFgReportDownloadSuccess = (payload) => {
  return {
    type: GET_FG_REPORT_DOWNLOAD_SUCCESS,
    payload: payload,
  };
};

const getFgReportDownloadFailure = (error) => {
  return {
    type: GET_FG_REPORT_DOWNLOAD_FAILURE,
    payload: error,
  };
};

const getFgReportDownload = (
  startDate,
  endDate,
  pageNo,
  rowsPerPage,
  search,
  jwtToken
) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getFgReportDownloadRequest());
    // let url = `${baseUrl}/reports/finish_goods?page_number=${
    //   pageNo + 1
    // }&startDate=${startDate}&endDate=${endDate}&rows_per_page=${rowsPerPage}&search=${search ? search : ""}&download=1`;
    let url = `${baseUrl}/reports/finish_goods?download=1&startDate=${endDate}&endDate=${startDate}&page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getFgReportDownloadSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getFgReportDownloadFailure(err.message));
      });
  };
};

const getFGTypeRequest = () => {
  return {
    type: GET_FG_TYPE_REQUEST,
  };
};

const getFGTypeSuccess = (payload) => {
  return {
    type: GET_FG_TYPE_SUCCESS,
    payload: payload,
  };
};

const getFGTypeFailure = (error) => {
  return {
    type: GET_FG_TYPE_FAILURE,
    payload: error,
  };
};

const getFGType = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getFGTypeRequest());
    let url = `${baseUrl}/reports/ageing/get_all`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getFGTypeSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(getFGTypeFailure(err.message));
      });
  };
};

const getFGModalRequest = () => {
  return {
    type: GET_FG_MODAL_REQUEST,
  };
};

const getFGModalSuccess = (payload) => {
  return {
    type: GET_FG_MODAL_SUCCESS,
    payload: payload,
  };
};

const getFGModalFailure = (error) => {
  return {
    type: GET_FG_MODAL_FAILURE,
    payload: error,
  };
};

const getFGModal = (documentTypeSelected, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getFGModalRequest());
    let url = `${baseUrl}/document_mvt_map/by_doc_id?documentId=${documentTypeSelected}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getFGModalSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(getFGModalFailure(err.message));
      });
  };
};

export { getFgReport, getFGType, getFGModal, getFgReportDownload };
